import { useHistory } from 'react-router-dom';
import styles from '@/containers/module-landing/module-card/index.scss';
import { PagePathV2 } from '@/types/index';
import { ModuleCardType } from '@/containers/module-landing/module-card/index';
import { LearningInfo } from '@/api/seller/serv/oec_seller_learning_center_api';
import { getImgSrc } from '@/utils/utils';
import { useEffect, useMemo, useState } from 'react';
import { getQuery } from '@i18n-ecom/lib/dist/commonjs/url';
import { IDENTITY_KEY } from '@/constants';

export const useModuleCard = (type: ModuleCardType, info?: LearningInfo) => {
  const [imgSrc, setImgSrc] = useState<string>();
  const history = useHistory();
  const style =
    type === ModuleCardType.ExploreModule
      ? styles.exploreModule
      : styles.hotModuleStyle;
  const queryIdentity = useMemo(
    () => Number(getQuery(location.search, IDENTITY_KEY)?.toString() ?? ''),
    [location.search],
  );
  const jumpToCourse = (learningId?: number) => {
    if (learningId) {
      history.push({
        pathname: PagePathV2.CourseDetail,
        search: `learning_id=${learningId}&identity=${queryIdentity}`,
      });
    }
  };
  useEffect(() => {
    getImgSrc(info?.image)
      .then(res => setImgSrc(res as string))
      .catch(err => setImgSrc(err));
  }, []);
  return {
    imgSrc,
    style,
    jumpToCourse,
  };
};
